import styled from 'styled-components';

import ButtonLink from '../../interface/ButtonLink';

export const CtaButton = styled(ButtonLink)`
  margin-top: 4rem;

  @media (${({ theme }) => theme.respondTo.mobile}) {
    width: 100%;
    text-align: center;
  }
`;

export const Title = styled.h2`
  font-family: var(--font-secondary);
  font-weight: var(--font-weight-regular);
  font-size: 5.2rem;
  line-height: 1.1;
  margin-bottom: 1.25rem;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    font-size: 6.4rem;
    margin-bottom: 10rem;
  }
`;
